import CrudPage from "../components/CrudPage";

export default function Suppliers() {
  return <CrudPage
    title="Fornecedores" subtitle="Parceiros e Fornecedores" endpoint="/suppliers" testPrefix="suppliers"
    fields={[
      { k: "name", label: "Nome" },
      { k: "phone", label: "Telefone" },
      { k: "email", label: "Email" },
      { k: "cnpj", label: "CNPJ" },
      { k: "notes", label: "Observações", hidden: true },
    ]}
  />;
}
